import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';
import Loader from '../components/Loader';
import FormContainer from '../components/FormContainer';
import { useForgotPasswordMutation } from '../slices/usersApiSlice';
import { toast } from 'react-toastify';

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      const res = await forgotPassword({ email }).unwrap();
      setIsSubmitted(true);
      toast.success(res.message || 'Wachtwoordherstel e-mail is verzonden');
    } catch (err) {
      toast.error(err?.data?.message || err.error || 'Er is een fout opgetreden');
    }
  };

  return (
    <FormContainer>
      <h1>Wachtwoord vergeten</h1>

      {isSubmitted ? (
        <div>
          <Alert variant='success'>
            <h4>E-mail verzonden!</h4>
            <p>
              Als er een account bestaat met het e-mailadres <strong>{email}</strong>,
              dan heeft u een e-mail ontvangen met instructies om uw wachtwoord te herstellen.
            </p>
            <p className='mb-0'>
              Controleer uw postvak in en eventueel uw spammaap.
            </p>
          </Alert>
          <div className='mt-3'>
            <Link to='/login'>
              <Button variant='secondary'>Terug naar inloggen</Button>
            </Link>
          </div>
        </div>
      ) : (
        <>
          <p className='text-muted'>
            Vul uw e-mailadres in. Wij sturen u een link om uw wachtwoord opnieuw in te stellen.
          </p>

          <Form onSubmit={submitHandler}>
            <Form.Group className='my-3' controlId='email'>
              <Form.Label>E-mailadres</Form.Label>
              <Form.Control
                type='email'
                placeholder='Uw e-mailadres'
                value={email}
                required
                onChange={(e) => setEmail(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Button disabled={isLoading} type='submit' variant='primary' className='mt-2'>
              Verstuur herstellink
            </Button>

            {isLoading && <Loader />}
          </Form>

          <Row className='py-3'>
            <Col>
              Herinnert u uw wachtwoord weer?{' '}
              <Link to='/login'>Inloggen</Link>
            </Col>
          </Row>
        </>
      )}
    </FormContainer>
  );
};

export default ForgotPasswordScreen;
